<template>
  <PartnerForm/>
</template>
<script>

import PartnerForm from "@/views/partners/PartnerForm.vue";

export default {
  name: "CreatePartnerPage",
  components: {PartnerForm},

}
</script>